import { DefaultChatTransport } from "ai";
import { fetchWithErrorHandlers } from "@/lib/utils";
import type { SolaContext, SolaMessage, SolaVisibilityType } from "./types";
import { logger } from "./logger";

export class SOLATransport extends DefaultChatTransport<SolaMessage> {
  private context: SolaContext;
  private visibilityType: SolaVisibilityType;

  constructor(
    context: SolaContext,
    visibilityType: SolaVisibilityType
  ) {
    logger.lifecycle('Transport constructor called', {
      candidatesCount: context.candidates?.length || 0,
      visibilityType
    });

    const superConfig = {
      api: "/api/sola/chat",
      fetch: fetchWithErrorHandlers,
      prepareSendMessagesRequest: (request: any) => {
        logger.state('prepareSendMessagesRequest called', {
          requestId: request.id,
          messagesCount: request.messages?.length || 0
        });

        // CRITICAL: Use current instance properties (updated via updateContext)
        const currentContext = this.context;
        const currentVisibility = this.visibilityType;

        logger.state('Preparing request', {
          requestId: request.id,
          messagesCount: request.messages?.length || 0,
          trigger: request.trigger,
          candidatesCount: currentContext.candidates?.length || 0,
          visibilityType: currentVisibility
        });

        const preparedRequest = {
          body: {
            id: request.id,
            messages: request.messages,
            trigger: request.trigger,
            messageId: request.messageId,
            selectedVisibilityType: currentVisibility,
            context: currentContext, // This will include the candidates array
          },
        };

        return preparedRequest;
      }
    };

    super(superConfig);

    // Now set instance properties after super() call
    this.context = context;
    this.visibilityType = visibilityType;

    logger.lifecycle('Transport constructor completed');
  }

  updateContext(newContext: Partial<SolaContext>) {
    this.context = { ...this.context, ...newContext };
    logger.state('Context updated', {
      candidatesCount: this.context.candidates?.length || 0,
      contextKeys: Object.keys(this.context)
    });
  }

  updateVisibility(visibility: SolaVisibilityType) {
    this.visibilityType = visibility;
  }
}